/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type StatEngineTable_query$ref = any;
export type NFLStatSortByInput = {|
  id: string,
  desc: boolean,
|};
export type NFLStatEngineQueryVariables = {|
  startWeek?: ?number,
  endWeek?: ?number,
  count?: ?number,
  cursor?: ?string,
  positions?: ?$ReadOnlyArray<?string>,
  sortBy?: ?NFLStatSortByInput,
  weeks?: ?$ReadOnlyArray<?number>,
  seasonID?: ?string,
|};
export type NFLStatEngineQueryResponse = {|
  +whoAmI: ?{|
    +groups: $ReadOnlyArray<{|
      +name: string
    |}>
  |},
  +$fragmentRefs: StatEngineTable_query$ref,
|};
export type NFLStatEngineQuery = {|
  variables: NFLStatEngineQueryVariables,
  response: NFLStatEngineQueryResponse,
|};
*/


/*
query NFLStatEngineQuery(
  $startWeek: Int
  $endWeek: Int
  $count: Int
  $cursor: String
  $positions: [String]
  $sortBy: NFLStatSortByInput
  $weeks: [Int]
  $seasonID: ID
) {
  whoAmI {
    groups {
      name
    }
    id
  }
  ...StatEngineTable_query_2hVe8V
}

fragment StatEngineTable_query_2hVe8V on Query {
  nflPlayerWeekStats(startWeek: $startWeek, endWeek: $endWeek, positions: $positions, sortBy: $sortBy, weeks: $weeks, seasonId: $seasonID) {
    headers {
      Header
      accessor
    }
    rows(first: $count, after: $cursor) {
      edges {
        node {
          player {
            firstName
            lastName
            position {
              name
              id
            }
            dkPlayer {
              id
            }
            injuryStatus
            team {
              id
              abbreviation
            }
            id
          }
          stats
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endWeek"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "positions"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seasonID"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startWeek"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weeks"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupType",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "kind": "Variable",
  "name": "endWeek",
  "variableName": "endWeek"
},
v11 = {
  "kind": "Variable",
  "name": "positions",
  "variableName": "positions"
},
v12 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v13 = {
  "kind": "Variable",
  "name": "startWeek",
  "variableName": "startWeek"
},
v14 = {
  "kind": "Variable",
  "name": "weeks",
  "variableName": "weeks"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NFLStatEngineQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "Variable",
            "name": "seasonID",
            "variableName": "seasonID"
          },
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "StatEngineTable_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "NFLStatEngineQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "Variable",
            "name": "seasonId",
            "variableName": "seasonID"
          },
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "concreteType": "NFLStatDataType",
        "kind": "LinkedField",
        "name": "nflPlayerWeekStats",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatDataHeader",
            "kind": "LinkedField",
            "name": "headers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "Header",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accessor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v16/*: any*/),
            "concreteType": "NFLStatDataRowConnection",
            "kind": "LinkedField",
            "name": "rows",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatDataRowEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NFLStatDataRowType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NFLStatPlayerType",
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NFLStatPositionType",
                            "kind": "LinkedField",
                            "name": "position",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PlayerType",
                            "kind": "LinkedField",
                            "name": "dkPlayer",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "injuryStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NFLStatTeamType",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "abbreviation",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stats",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v16/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "StatTable_rows",
            "kind": "LinkedHandle",
            "name": "rows"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0493f678be5b8459550ef303de34d6d1",
    "id": null,
    "metadata": {},
    "name": "NFLStatEngineQuery",
    "operationKind": "query",
    "text": "query NFLStatEngineQuery(\n  $startWeek: Int\n  $endWeek: Int\n  $count: Int\n  $cursor: String\n  $positions: [String]\n  $sortBy: NFLStatSortByInput\n  $weeks: [Int]\n  $seasonID: ID\n) {\n  whoAmI {\n    groups {\n      name\n    }\n    id\n  }\n  ...StatEngineTable_query_2hVe8V\n}\n\nfragment StatEngineTable_query_2hVe8V on Query {\n  nflPlayerWeekStats(startWeek: $startWeek, endWeek: $endWeek, positions: $positions, sortBy: $sortBy, weeks: $weeks, seasonId: $seasonID) {\n    headers {\n      Header\n      accessor\n    }\n    rows(first: $count, after: $cursor) {\n      edges {\n        node {\n          player {\n            firstName\n            lastName\n            position {\n              name\n              id\n            }\n            dkPlayer {\n              id\n            }\n            injuryStatus\n            team {\n              id\n              abbreviation\n            }\n            id\n          }\n          stats\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e0a593b8043133b937712fd4402b37ef';

module.exports = node;
